module.exports = __webpack_public_path__ + "img/bg_modal_card.a6dec5b6.svg";